import {FormArray, FormControl, Validators} from '@angular/forms';


export enum ControlType {
  BOOLEAN = 0,
  RADIO = 1,
  MULTI = 2,
  TEXT = 3,
  INTEGER = 4,
  DECIMAL = 5,
  DEVICES = 6,
  DROPDOWN = 7,
  DATETIME = 8,
  // DURATION = 9,
  // EXPRESSION = 10,
  //PICTURE = 11,
  //TIMESTAMP = 12,
  DATE = 13,
  // CONDITION = 14,
  DATERANGE = 15,
  //DATETIME= 16 removed

}



export class ServiceFormItem {
  name: string;
  type: ControlType;
  renderTag: string;
  description: string;
  required: boolean;
  sort?: number;
  values?: string[];

  constructor(name?: string,
              type?: ControlType,
              tag?: string,
              description?: string,
              required?: boolean,
              sort?: number,
              values?: string[]) {
    this.name = name;
    this.type = type;
    this.renderTag = tag;
    this.description = description;
    this.required = required;
    this.sort = sort;
    this.values = values && [...values];
  }

  toMap(item: ServiceFormItem): Map<string, unknown> {
    const map = new Map<string, unknown>();
    map.set('name', item.name);
    map.set('type', item.type);
    map.set('renderTag', item.renderTag);
    map.set('description', item.description);
    map.set('required', item.required ?? false);
    map.set('sort', item.sort ?? 0);
    if (item.values?.length > 0) {
      const values = [];
      item.values.forEach((v) => {
        values.push(v);
      });
      map.set('values', values);
    }
    return map;
  }
}

export class ServiceItemForm {
  name = new FormControl();
  type = new FormControl();
  renderTag = new FormControl();
  description = new FormControl();
  required = new FormControl(true);
  sort = new FormControl();
  values = new FormArray([]);

  constructor(
    item: ServiceFormItem,
  ) {
    if (item.name) {
      this.name.setValue(item.name);
    }
    if (item.type) {
      this.type.setValue(item.type);
    }
    if (item.renderTag) {
      this.renderTag.setValue(item.renderTag);
    }
    if (item.required !== undefined) {
      this.required.setValue(item.required);
    }
    if (item.description !== undefined) {
      this.description.setValue(item.description);
    }
    if (item.sort !== undefined) {
      this.sort.setValue(item.sort);
    }
    this.type.setValue(item.type);

    this.name.setValidators([Validators.required]);
    this.name.updateValueAndValidity();
    this.renderTag.setValidators([Validators.required]);
    this.renderTag.updateValueAndValidity();
    this.type.setValidators([Validators.required]);
    this.type.updateValueAndValidity();
    this.required.setValidators([Validators.required]);
    this.required.updateValueAndValidity();

    if (item.values !== undefined && item.values.length > 0 && item.values[0] !== '') {
      item.values.forEach(i => {
        this.values.push(new FormControl(i));
      });
      this.values.setValidators(Validators.required);
    }
  }
}
